import React from "react";
import { cn } from "@/lib/utils";

interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

interface SegmentedFilterProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/**
 * Pill-style segmented filter component.
 * Use instead of tabs for filtering content.
 */
const SegmentedFilter: React.FC<SegmentedFilterProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  return (
    <div 
      className={cn(
        "flex items-center gap-2 p-1 bg-muted/50 rounded-lg overflow-x-auto",
        className
      )}
    >
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium",
            "transition-colors whitespace-nowrap shrink-0",
            value === option.value
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {option.label}
          {typeof option.count === "number" && option.count > 0 && (
            <span className={cn(
              "px-1.5 py-0.5 text-xs rounded-full",
              value === option.value
                ? "bg-primary/10 text-primary"
                : "bg-muted text-muted-foreground"
            )}>
              {option.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default SegmentedFilter;
